import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuyer = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3516 18.2968C10.3516 18.6852 10.0368 19 9.64845 19H1.70313C1.31476 19 1 18.6852 1 18.2968V8.61724C1 8.4085 1.0927 8.21061 1.25296 8.07713L9.54984 1.16304C9.81063 0.945652 10.1894 0.945652 10.4502 1.16304L18.7471 8.07713C19.0453 8.32569 19.0856 8.76899 18.837 9.0674C18.5884 9.36568 18.145 9.40592 17.8467 9.15735L10 2.61845L2.40625 8.94655V17.5937H9.64845C10.0368 17.5937 10.3516 17.9085 10.3516 18.2968ZM17.887 16.3947C17.1154 17.3248 15.9634 18.1764 14.4627 18.9259C14.2648 19.0247 14.0321 19.0247 13.8342 18.9259C12.3335 18.1764 11.1815 17.3248 10.4101 16.3947C8.11997 13.634 9.71464 10.5871 12.0742 10.5871C13.0145 10.5871 13.7063 10.972 14.1485 11.3333C14.5907 10.972 15.2824 10.5871 16.2227 10.5871C18.5868 10.5871 20.1713 13.6407 17.887 16.3947ZM16.2227 11.9933C15.25 11.9933 14.7394 12.7225 14.7344 12.7298C14.4425 13.1702 13.8268 13.1433 13.5643 12.7327C13.5211 12.6721 13.0163 11.9933 12.0742 11.9933C10.5587 11.9933 9.25692 14.914 14.1485 17.5062C19.04 14.914 17.7385 11.9933 16.2227 11.9933Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .5
	})
});
export default SvgBuyer;
